import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import DocumentsService from '../../shared/services/DocumentsService';
import {CompanyType} from '../../shared/CommonInterfaces';
import InboundService from '../../shared/services/InboundService';
import WarehouseInboundContext, {WarehouseInboundContextValues} from '../contexts/WarehouseInboundContext';
import FulfillmentInbound from '../../dropoffs/fulfillment/FulfillmentInbound';
import ContainersService from '../../shared/services/ContainersService';
import WarehouseService from '../../shared/services/WarehouseService';
import PackingListService from '../../shared/services/PackingListService';
import InboundDeliveryDetails from './InboundDeliveryDetails';

interface InboundProps {
  authenticityToken: string;
  receivingListPath: string;
  enableInboundPackaging: boolean;
  enableLpn: boolean;
  lpnReceiveOnly: boolean;
  containerDeliveryId: number;
  warehouseId: number;
  showEditLpnForAsn: boolean;
  allowLpnTransferInAllInboundStates: boolean;
}

const InboundDeliveriesRouter: React.FC<InboundProps> = (props) => {
  const inboundService = new InboundService();
  const documentsService = new DocumentsService(CompanyType.warehouse);
  const containersService = new ContainersService(props.authenticityToken);
  const packingListService = new PackingListService(props.authenticityToken);
  const warehouseService = new WarehouseService(props.authenticityToken);

  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  const inboundContextValues: WarehouseInboundContextValues = {
    inboundService,
    documentsService,
    containersService,
    packingListService,
    warehouseService
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <WarehouseInboundContext.Provider value={inboundContextValues}>
        <Router>
          <Switch>
            <Route
              path="/wh/dropoffs/container/:id"
              render={() => {
                if (props.lpnReceiveOnly || props.enableLpn) {
                  return (
                    <InboundDeliveryDetails
                      inboundId={props.containerDeliveryId}
                      warehouseId={props.warehouseId}
                      enableInboundPackaging={props.enableInboundPackaging}
                      enableLpn={props.enableLpn}
                      lpnReceiveOnly={props.lpnReceiveOnly}
                      showEditLpnForAsn={props.showEditLpnForAsn}
                      allowLpnTransferInAllInboundStates={props.allowLpnTransferInAllInboundStates}
                      receivingListPath={props.receivingListPath}
                    />
                  );
                } else {
                  // this can leave in /dropoffs directory for now.
                  // we will later move this to inbounds directory after full lpn and decompose lpn changes are done
                  return <FulfillmentInbound />;
                }
              }}
            />
          </Switch>
        </Router>
      </WarehouseInboundContext.Provider>
    </FlexeContext.Provider>
  );
};

export default InboundDeliveriesRouter;
